import script from "./pdf-link.vue?vue&type=script&setup=true&lang=ts"
export * from "./pdf-link.vue?vue&type=script&setup=true&lang=ts"

import "./pdf-link.vue?vue&type=style&index=0&id=22737e8a&lang=scss"

const __exports__ = script;

export default __exports__